import { useEffect, useRef, useState } from "react";
import { AddVerifiedCompetencyData } from "./data/AddVerifiedCompetency.data";
import FormCreator from "../../components/Forms/FormCreator";
import Buttons from "../../components/ui/button/Buttons";
import { useNavigate } from "react-router-dom";
import { useAddCompetencyForMemberByAdminMutation, useGetGMAPMemberByGMPNumberOrNameMutation } from "../../app/services/GMAP/verifiedCompetency";
import ToastService from "../../services/toastService/ToastService";
import { useLazyGetAllDropDownsForMemberDirectoryQuery, useLazyGetPDFQuery, useUploadPDFMutation } from "../../app/services/common/commonApi";
import { setDropDownField } from "./utils/setFieldParameter";
import { APIUrl } from "../../utils/API/fetchBaseQuery";
import SwalAlert from "../../services/swalService/SwalService";

const AddEditVerifiedCompetency = () => {
    const addVerifiedCompetencyRef = useRef();
    const [formData, setFormData] = useState(AddVerifiedCompetencyData);
    const navigate = useNavigate();
    const [uploadData, setUploadData] = useState({
        fileName: "",
        uploadedFileName: ""
    });
    const [memberId, setMemberId] = useState(0);
    const { success, error } = SwalAlert();
    const [fetchMembers, { isSuccess: isMemberSuccess, isLoading: isMemberLoading, data: memberData },] = useGetGMAPMemberByGMPNumberOrNameMutation();
    const [addCompetencyForMember, { isSuccess: isAddMemberSuccess, isLoading: isAddMemberLoading, data: addMemberData },] = useAddCompetencyForMemberByAdminMutation();
    const [getAllDropDowns, { isLoading: getDropdownDataIsLoading, data: getDropdownData, isSuccess: getAllDropdownDataIsSuccess },] = useLazyGetAllDropDownsForMemberDirectoryQuery();
    const [uploadPDF, { isSuccess: isUploadSuccess, isLoading: isUploadLoading, data: fileUploadData }] = useUploadPDFMutation();
    const [getPDF] = useLazyGetPDFQuery();

    useEffect(() => {
        getAllDropDowns();
    }, []);

    useEffect(() => {
        if (!isUploadLoading && isUploadSuccess && fileUploadData) {
            setUploadData({
                fileName: fileUploadData?.fileName,
                uploadedFileName: fileUploadData?.uploadedFileName
            });
        }
    }, [isUploadLoading, isUploadSuccess, fileUploadData,]);

    useEffect(() => {
        if (!isAddMemberLoading && isAddMemberSuccess && addMemberData) {
            success("Record has been updated successfully.", "Successful");
            handleClearForm();
            setTimeout(() => {
                navigate('/verifiedCompetency');
            }, 2000);
        }
    }, [isAddMemberLoading, isAddMemberSuccess, addMemberData,]);

    useEffect(() => {
        if (!getDropdownDataIsLoading && getAllDropdownDataIsSuccess && getDropdownData) {
            setDropDownField(getDropdownData)
        }
    }, [getDropdownDataIsLoading, getDropdownData, getAllDropdownDataIsSuccess]);

   useEffect(() => {
    if (isMemberLoading || !isMemberSuccess || !memberData) return;
    const { gmapMemberId, fullName } = memberData;
    const hasValidMember = gmapMemberId > 0;
    const gmpNumber = addVerifiedCompetencyRef.current.getFieldValue("gmpNumber") || null;

    setFormData(prev => ({
        ...prev,
        initialState: {
            ...prev.initialState,
            gmpName: hasValidMember ? fullName || "" : "",
            gmpNumber
        }
    }));

    if (hasValidMember) {
        setMemberId(gmapMemberId);
        ToastService.success("Member Found Successfully!");
    } else {
        setMemberId(0);
        ToastService.error("Member Not Found!");
    }
}, [isMemberSuccess, memberData, isMemberLoading]);


    const handleSearch = () => {
        const gmpNumber = addVerifiedCompetencyRef.current.getFieldValue("gmpNumber");
        if (!gmpNumber) { return; }
        const updatedRequest = {
            GMPNumber: gmpNumber || null,
        };
        fetchMembers(updatedRequest);
    };

    const handleSubmit = () => {
        const formData = addVerifiedCompetencyRef.current.getFormData();
        if (!formData) {
            return;
        }
        if (memberId == 0) {
            error("Member Not Found", "Unsucessful");
            return
        }
        const updatedRequest = {
            GmapMemberId: memberId || null,
            VerifiedCompetencyId: formData?.verifiedCompetency?.value || formData?.verifiedCompetency,
            DateOfCertificate: formData?.dateofCertificate || null,
            CompetencyFileName: uploadData?.uploadedFileName || null,
            CompetencyFile: uploadData?.fileName || null,
            InternalComments: formData?.internalComments || null,
            GMPNumber: formData?.gmpNumber || null,
        };
        addCompetencyForMember(updatedRequest);
    };

    const handleOnChangeFileUpload = async (data) => {
        let formData = new FormData();
        formData.append("file", data)
        formData.append("storagePath", "VerfiedCompetency");
        uploadPDF(formData);
    }

    const handleFormFieldChange = (dataField, value) => {
        if (dataField === "uploadFile" && value) {
            if (value.type === "application/pdf") {
                handleOnChangeFileUpload(value);
            }
        }
    };

    const handleDownload = async (data, dataField) => {

        const request = {
            type: "",
            fileName: fileUploadData?.fileName,
        }
        if (dataField === "uploadFile") {
            request.type = "VerfiedCompetency"
        }

        const response = await getPDF(request);
        const fileUrl = `${APIUrl}/Common/getPDF?type=VerfiedCompetency&fileName=${response?.data?.fileName}`;
        window.open(fileUrl, "_blank");
    }

    const handleClearForm = () => {
        const clearedForm = {
            ...AddVerifiedCompetencyData,
            initialState: {
                gmpNumber: "",
                gmpName: "",
                verifiedCompetency: 0,
                dateofCertificate: '',
                uploadFile: "",
                internalComments: ""
            },
        };

        setFormData(clearedForm);
        getAllDropDowns();
    };

    const handleClear = () => {
        const updatedForm = { ...AddVerifiedCompetencyData };
        updatedForm.initialState.uploadFile = null;
        setFormData(updatedForm);
    }

    const formActionHandler = {
        CLEAR: handleClear,
        DOWNLOAD: handleDownload,
    }

    const handleBack = () => {
        navigate("/verifiedCompetency");
    };

    return (
        <>
            <div>
                <div className="row">
                    <div className="col-lg-8">
                        {!getDropdownDataIsLoading &&
                            <div className="">
                                <FormCreator ref={addVerifiedCompetencyRef}
                                    {...formData}
                                    onActionChange={formActionHandler}
                                    onFormFieldValueChange={handleFormFieldChange}
                                />
                            </div>
                        }
                    </div>
                    <div className="col-lg-4 d-flex">
                        <Buttons
                            buttonText={"Search"}
                            buttonTypeClassName="success-btn  btn mt-4 mb-3"
                            onClick={handleSearch}
                        />
                    </div>
                </div>

                <div className="mt-4 d-flex justify-content-between">
                    <Buttons
                        buttonText="Back"
                        buttonTypeClassName="black-btn "
                        onClick={handleBack}
                    />
                    <Buttons
                        buttonText="Submit"
                        buttonTypeClassName="success-btn"
                        onClick={handleSubmit}
                        isLoading={isAddMemberLoading}
                        isDisable={isAddMemberLoading}
                    />
                </div>
            </div>
        </>
    );
};
export default AddEditVerifiedCompetency;
